import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {Deadwood} from "../../Deadwood";
import {DeadwoodGameModuleConfig} from "../../DeadwoodGameModuleConfig";

export class DeadwoodWinFieldController extends WinFieldController {
    public showWinField(to?: number, forceWin: boolean = false, forceTotalWin: boolean = false): void {
        if (this.shouldShow()) {
            to = to != null ? to : this._totalWin;

            if (!forceWin && (forceTotalWin || this._shouldShowTotalWin || this._shouldNextShowTotalWin)) {
                SlotGame.keypad.setWin(to, true, DeadwoodGameModuleConfig.isRestore ? this.calculateBelowStakeWinForRestoreOnly(to) : BelowStakeWinRestriction.isWinBelowStake(to, Deadwood.model.gameData?.playedBetValue));
                return;
            }
            SlotGame.keypad.setWin(to);
        }
    }

    private calculateBelowStakeWinForRestoreOnly(accumulatedRoundWin: number): boolean {
        try {
            const winStake:boolean=Deadwood.api.gameClientConfiguration.belowStakeWinRestriction,
                featurePrice:number=this.getBuyFeaturePrice();
            return  winStake && (accumulatedRoundWin <= featurePrice);
        } catch (err) {
            return false;
        }
    }
    private getBuyFeaturePrice(playedBetVal?: number, wasFeatureBuy?: boolean): number {
        const betLevel: string = Deadwood.api.freeBets.hasFreeBets() ? Deadwood.api.freeBets.getBet() : Deadwood.api.betLevel.getLevel();
        let price: number = playedBetVal ? playedBetVal : (Deadwood.model.gameData?.playedBetValue || parseFloat(betLevel));

        const activeFeature = Deadwood.api.betFeatureController.getActiveBetFeature();
        if (activeFeature) {
            price = activeFeature.getTotalCost();
        }
        return price;
    }
}